export default __webpack_public_path__ + "static/media/Task flow.23ed0777.svg";